/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_YouInputs */

const en_us2_exercise_personal_strength_you = /** @type {(inputs: Exercise_Personal_Strength_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← you`)
};

const pt_br2_exercise_personal_strength_you = /** @type {(inputs: Exercise_Personal_Strength_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← você`)
};

const es_419_exercise_personal_strength_you = /** @type {(inputs: Exercise_Personal_Strength_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← tú`)
};

const pt_pt2_exercise_personal_strength_you = /** @type {(inputs: Exercise_Personal_Strength_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← tu`)
};

const fr_fr2_exercise_personal_strength_you = /** @type {(inputs: Exercise_Personal_Strength_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← toi`)
};

const de_de2_exercise_personal_strength_you = /** @type {(inputs: Exercise_Personal_Strength_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← du`)
};

const it_it2_exercise_personal_strength_you = /** @type {(inputs: Exercise_Personal_Strength_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← tu`)
};

/**
* | output |
* | --- |
* | "← you" |
*
* @param {Exercise_Personal_Strength_YouInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_you = /** @type {((inputs?: Exercise_Personal_Strength_YouInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_YouInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_you(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_you(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_you(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_you(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_you(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_you(inputs)
	return en_us2_exercise_personal_strength_you(inputs)
});
export { exercise_personal_strength_you as "exercise-personal.strength_you" }